import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { fmtDate, fmtBudget, fmtDuree, L } from "@/constants/labels";
import { NetPercu, NetPercuFourchette } from "@/components/commission/Commission";

export default function Besoins() {
  const { user } = useAuth();
  const [rows, setRows] = useState([]); const [mine, setMine] = useState(false);
  useEffect(() => {
    (async () => {
      const { data } = await api.get("/besoins", { params: { mine } });
      setRows(data);
    })();
  }, [mine]);
  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h1 className="text-2xl md:text-3xl font-semibold text-[#1F2933]">{L.wording.besoinsListH1}</h1>
        <div className="flex gap-2">
          {user?.role === "entreprise" && (
            <>
              <button onClick={() => setMine(!mine)} className={mine ? "btn-primary" : "btn-outline"} data-testid="besoins-mine">{mine ? "Voir tous" : "Voir les miens"}</button>
              <Link to="/app/chantiers/nouveau" className="btn-accent" data-testid="besoins-new">{L.wording.besoinsListPublier}</Link>
            </>
          )}
        </div>
      </div>
      <div className="mt-4 card overflow-x-auto">
        <table className="table-compact w-full">
          <thead><tr><th>Titre</th><th>Métier</th><th>Localisation</th><th>Budget</th><th>Durée</th><th>Échéance</th><th>Candidatures</th><th></th></tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={8} className="text-center text-[#3E4C59]">{L.common.none}</td></tr>}
            {rows.map(b => (
              <tr key={b.id} data-testid={`besoin-row-${b.id}`}>
                <td className="font-semibold">{b.titre}</td>
                <td>{[b.metier, b.specialite].filter(Boolean).join(" • ")}</td>
                <td>{b.ville} ({b.code_postal})</td>
                <td>{fmtBudget(b)}{user?.role === "prestataire" && (
                  <div>{b.budget_type === "fourchette" ? <NetPercuFourchette min={b.budget_min} max={b.budget_max} testid={`net-percu-${b.id}`} /> : <NetPercu montant={b.budget_ht} compact testid={`net-percu-${b.id}`} />}</div>
                )}</td>
                <td>{fmtDuree(b)}</td>
                <td>{fmtDate(b.date_fin)}</td>
                <td>{b.nb_candidatures}</td>
                <td><Link to={`/app/chantiers/${b.id}`} className="btn-outline">Consulter</Link></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
